// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import SectionContainer from '../SectionContainer';
import PayInfoSection from '../../createWorkOrder/formFields/payInfoSection';
import MarksSection from './section/workOrder/MarksSection';
import CustomFieldsSection from './section/workOrder/customFieldsSection';
import TasksSection from './section/workOrder/tasksSection';
import DateSection from '../../createWorkOrder/formFields/DateSection';
import SiteInfoSection from '../../createWorkOrder/formFields/SiteInfoSection';
import AddressSection from '../../createWorkOrder/formFields/AddressSection';
import WorkOrderWorkTypesSection from './section/workOrder/WorkTypesSection';
import EditorField from './customFields/EditorField';
import ContactInfoSection from './section/workOrder/ContactInfoSection';
import UploadDocumentsSection from './section/workOrder/uploadDocumentsSection';
import CreateTemplateSection from './section/workOrder/CreateTemplateSection';
import ControlButtonsForCreateAndEditWorkOrder from '../../createWorkOrder/formFields/ControlButtonsForCreateAndEditWorkOrder';
import { toggleModal } from '../../../storage/actions/modalsActions';
import Notification from '../../notification';
import defaultInitialValues from '../../../utils/reduxForm/InitialValues/createWorkOrderReduxForm';
import { normalizeWorkOrderFormDates } from '../../../utils/getDateWithOffset';
import TeamSection from '../../createWorkOrder/formFields/TeamSection';
import RemoteWFHSection from '../../createWorkOrder/formFields/Remote-WFHSection';
import ClientApprovalCodeSection from './section/workOrder/clietnApprovalSection';

// import '../../../sass/order/order-l.scss';
// import '../../../sass/order/order-m.scss';
// import '../../../sass/order/order.scss';


let CreateWorkOrderReduxForm = ({
  handleSubmit,
  error,
  toggleModal,
  history,
  currentWorkOrder,
  templateId,
  anyTouched,
  setTouched,
}) => {
  useEffect(() => {
    setTouched(anyTouched);
  }, [anyTouched]);

  useEffect(() => {
    if (error) Notification('error', { message: error });
  }, [error]);

  const preventSubmitOnEnter = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  };

  return (
    <Form onSubmit={handleSubmit} onKeyPress={preventSubmitOnEnter}>
      {/* <SectionContainer> */}
      <div className="create_fields">
        <PayInfoSection isWorkOrderAssigned={currentWorkOrder?.status === 'assigned'} />
        <MarksSection
          toggleModal={toggleModal}
        />
          <div className="create-wo-columns create-wo-columns--pair">
              <div className="create-wo-column">
                  <CustomFieldsSection toggleModal={toggleModal} />
              </div>
              <div className="create-wo-column">
                  <ClientApprovalCodeSection toggleModal={toggleModal} />
              </div>
          </div>
          <div className="create-wo-column create-wo-column--block">
              <TasksSection />
          </div>
        <DateSection />
        {/* <SiteInfoSection /> */}
        <AddressSection />
        <div className='ml-3'>- OR -</div>
        <RemoteWFHSection />
        <WorkOrderWorkTypesSection />
        <Field
          component={EditorField}
          label="Work Description"
          required
          name="description"
          className="flex-column"
        />
          <br />
          <Field
          component={EditorField}
          label="Tools Required"
          name="customTools"
          className="flex-column"
        />
          <br />
          <Field
          component={EditorField}
          label="Confidential Information: (Shown ONLY After Assigned)"
          name="confidential"
          className="flex-column"
        />
        <ContactInfoSection />
        <div className="fields_group">
          <TeamSection formName="createWorkOrderReduxForm" />
        </div>

        <UploadDocumentsSection toggleModal={toggleModal} />

        <CreateTemplateSection templateId={templateId} currentWorkOrderId={currentWorkOrder?._id} />
      </div>
      {/* </SectionContainer> */}
      <ControlButtonsForCreateAndEditWorkOrder
        editingWorkOrderStatus={currentWorkOrder?.status}
        history={history}
      />
    </Form>
  );
};

CreateWorkOrderReduxForm = reduxForm({
  form: 'createWorkOrderReduxForm',
  enableReinitialize: true,
})(CreateWorkOrderReduxForm);

const mapDispatchToProps = {
  toggleModal,
};

const mapStateToProps = state => {
  const { currentWorkOrder, currentTemplate } = state.workOrder;
  let initialValues = defaultInitialValues;

  if (currentWorkOrder?._id) {
    initialValues = normalizeWorkOrderFormDates(currentWorkOrder);
  } else if (currentTemplate?.templateId) {
    initialValues = normalizeWorkOrderFormDates({
      ...defaultInitialValues,
      ...currentTemplate,
    });
  }

  return {
    activeTab: state.applicationState.activeTab,
    currentWorkOrder,
    addressDisabled: state.workOrder.addressDisabled,
    templateId: currentTemplate?.templateId,
    initialValues,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CreateWorkOrderReduxForm));
